/**
 * Map P1a eligible-workspace `access_level` to write/manage capabilities.
 *
 * Mirrors backend `workspacePermissionService.getRolePermissions` /
 * ACCESS_CONTROL_MODEL §2 for the labels returned by
 * GET /workspace-bill-tracking/workspaces (system_admin | org_admin | owner |
 * contributor | guest). Used only for Pro tracking UI gating — server denial
 * remains authoritative.
 */

export type TrackingCapabilities = {
  canWrite: boolean;
  canManage: boolean;
};

/**
 * Derive track/hot/priority (canWrite) vs position (canManage) from access_level.
 * Unknown / missing levels deny both so the UI never optimistically enables
 * a write the server will 403.
 */
export function trackingCapabilitiesFromAccessLevel(
  accessLevel?: string | null,
): TrackingCapabilities {
  const level = (accessLevel ?? '').trim().toLowerCase();
  switch (level) {
    case 'system_admin':
    case 'org_admin':
    case 'owner':
      return { canWrite: true, canManage: true };
    case 'contributor':
      return { canWrite: true, canManage: false };
    case 'guest':
    default:
      return { canWrite: false, canManage: false };
  }
}

export default trackingCapabilitiesFromAccessLevel;
